// extracted by mini-css-extract-plugin
export default {"customWidth":"publishing-options-dropdown-module__customWidth--zY7Kd"};